import { graphql } from "@opensea/graphql"
import { CancelOrderFlowStatus_orderFragment } from "../CancelOrderFlowStatus/CancelOrderFlowStatus.fragment"
import { CancelOrderTableFragment } from "../CancelOrderTable/CancelOrderTable.fragment"

export const GaslessCancelOrderStatusFragment = graphql(
  `
    fragment GaslessCancelOrderStatus on GaslessCancelOrdersAction {
      orders {
        side
        id
        ...CancelOrderFlowStatus_order
        ...CancelOrderTable
      }
    }
  `,
  [CancelOrderTableFragment, CancelOrderFlowStatus_orderFragment],
)
